import { Box, styled } from '@mui/material';
import { DentistInfo } from 'new/modules/EnrollPage/types';
import React from 'react';
import { useIntl } from 'react-intl';
import { commonLandingPageStyles } from '../../styles';

const Wrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  padding: '0',

  '.title': {
    fontWeight: 'bold',
    fontSize: '1rem',
    display: 'block',
  },
  '.familyDiscount': {
    ...commonLandingPageStyles,
    textAlign: 'center',
    fontSize: '0.9rem',
    lineHeight: '1.2rem',
    padding: '0.8rem',
    margin: '0 0.5rem',
  },
  '.familyDiscountClassic': {
    backgroundColor: '#f2f2f2',
    border: '1px solid #ccc',
    textAlign: 'center',
    fontSize: '0.9rem',
    lineHeight: '1.2rem',
    padding: '0.8rem',
    margin: '0 0.5rem',
  },
}));

type Props = {
  isNewTheme: boolean;
  dentistInfo: DentistInfo;
};

const FamilyDiscounts: React.FC<Props> = ({ dentistInfo, isNewTheme }) => {
  const intl = useIntl();
  const allEqual =
    !!dentistInfo.family_discount_two &&
    dentistInfo.family_discount_two == dentistInfo.family_discount_three &&
    dentistInfo.family_discount_three == dentistInfo.family_discount_four;
  const familyDiscount2 =
    !allEqual &&
    dentistInfo.family_discount_two &&
    dentistInfo.family_discount_two !== dentistInfo.family_discount_three
      ? dentistInfo.family_discount_two
      : 0;
  const familyDiscount3 =
    !allEqual &&
    dentistInfo.family_discount_three &&
    dentistInfo.family_discount_three !== dentistInfo.family_discount_four
      ? dentistInfo.family_discount_three
      : 0;
  const familyDiscount3orMore =
    !allEqual &&
    dentistInfo.family_discount_three &&
    dentistInfo.family_discount_two !== dentistInfo.family_discount_three &&
    dentistInfo.family_discount_three === dentistInfo.family_discount_four
      ? dentistInfo.family_discount_three
      : 0;
  const familyDiscount4 =
    !allEqual &&
    dentistInfo.family_discount_four &&
    dentistInfo.family_discount_two !== dentistInfo.family_discount_three &&
    dentistInfo.family_discount_three !== dentistInfo.family_discount_four
      ? dentistInfo.family_discount_four
      : 0;

  if (
    !allEqual &&
    !familyDiscount2 &&
    !familyDiscount3 &&
    !familyDiscount3orMore &&
    !familyDiscount4
  )
    return null;

  return (
    <Wrapper>
      <Box className={isNewTheme ? 'familyDiscount' : 'familyDiscountClassic'}>
        <Box className="title">
          {intl.formatMessage({
            id: 'signup.externalLanding.familyDiscounts.title',
          })}
        </Box>
        {allEqual && (
          <>
            {' '}
            {intl.formatMessage(
              { id: 'signup.externalLanding.familyDiscounts.discount' },
              {
                percent: dentistInfo.family_discount_two,
                count: intl.formatMessage(
                  { id: 'label.numberOrMore' },
                  { number: 2 },
                ),
              },
            )}
          </>
        )}
        {!!familyDiscount2 && (
          <>
            {' '}
            {intl.formatMessage(
              { id: 'signup.externalLanding.familyDiscounts.discount' },
              {
                percent: familyDiscount2,
                count: 2,
              },
            )}
            {','}
          </>
        )}
        {!!familyDiscount3 && (
          <>
            {' '}
            {intl.formatMessage(
              { id: 'signup.externalLanding.familyDiscounts.discount' },
              {
                percent: familyDiscount3,
                count: 3,
              },
            )}
            {','}
          </>
        )}
        {!!familyDiscount3orMore && (
          <>
            {' '}
            {intl.formatMessage(
              { id: 'signup.externalLanding.familyDiscounts.discount' },
              {
                percent: familyDiscount3orMore,
                count: intl.formatMessage(
                  { id: 'label.numberOrMore' },
                  { number: 3 },
                ),
              },
            )}
          </>
        )}
        {!!familyDiscount4 && (
          <>
            {' '}
            {intl.formatMessage(
              { id: 'signup.externalLanding.familyDiscounts.discount' },
              {
                percent: familyDiscount4,
                count: intl.formatMessage(
                  { id: 'label.numberOrMore' },
                  { number: 4 },
                ),
              },
            )}
          </>
        )}
      </Box>
    </Wrapper>
  );
};

export default FamilyDiscounts;
